import {
  IAttributeDefinition,
  WSDataTypes
} from "@wingspanhq/payments/dist/interfaces";
import * as Yup from "yup";

import { validatorStringGeneric } from "../../../../shared/validators/validatorStringGeneric";

function getFieldValidaitonSchema(definition: IAttributeDefinition) {
  let baseValidator;
  switch (definition.type) {
    case WSDataTypes.Boolean:
      baseValidator = Yup.boolean();
      break;

    case WSDataTypes.Number:
      baseValidator = Yup.number().nullable();

      if (definition.validationRules?.minimum !== undefined) {
        baseValidator = baseValidator.min(
          definition.validationRules.minimum,
          `Minimum value is ${definition.validationRules.minimum}`
        );
      }

      if (definition.validationRules?.maximum !== undefined) {
        baseValidator = baseValidator.max(
          definition.validationRules.maximum,
          `Maximum value is ${definition.validationRules.maximum}`
        );
      }
      break;

    case WSDataTypes.Datetime:
      baseValidator = Yup.date().nullable();
      break;

    case WSDataTypes.String:
    default:
      baseValidator = validatorStringGeneric.nullable();

      if (definition.validationRules?.regex) {
        baseValidator = baseValidator.matches(
          new RegExp(definition.validationRules?.regex),
          "Not valid"
        );
      }
  }

  if (definition.required) {
    return baseValidator.required("Required");
  }

  return baseValidator;
}

export function getAttributeValidators(
  attributeDefinitions: IAttributeDefinition[]
) {
  return attributeDefinitions.reduce(
    (acc, definition) => ({
      ...acc,
      [definition.key]: getFieldValidaitonSchema(definition)
    }),
    {}
  );
}
